<template>
  <div class="time-slots">
    <h3 class="time-slots-title">
      <span v-if="selectedTrainerName" class="trainer-name"> для {{ selectedTrainerName }}</span>
    </h3>

    <div v-if="selectedDate" class="selected-date">
      {{ formattedDate }}
    </div>

    <div v-if="slots.length === 0" class="no-slots">
      <p>На выбранную дату нет доступных слотов</p>
    </div>

    <div v-else class="slots-grid">
      <button
        v-for="slot in slots"
        :key="slot.id"
        class="slot-button"
        :class="{ active: isSelected(slot.id) }"
        @click="selectSlot(slot.id)"
      >
        <div class="slot-time">{{ slot.time }}</div>
        <div class="slot-price">от {{ formatPrice(slot.minPrice, slot.currency) }}</div>
      </button>
    </div>
  </div>
</template>

<script setup>
/* global defineProps, defineEmits */
import { computed } from 'vue'
import { formatCurrencyPrice, pickPreferredCurrency } from '@/widgets/booking/utils/currency'

const props = defineProps({
  slots: {
    type: Array,
    required: true
  },
  selectedDate: {
    type: String,
    default: undefined
  },
  selectedTrainerName: {
    type: String,
    default: undefined
  },
  currency: {
    type: String,
    default: 'RUB'
  },
  modelValue: {
    type: Number,
    default: undefined
  }
})

const emit = defineEmits(['update:modelValue'])

const formattedDate = computed(() => {
  if (!props.selectedDate) return ''
  const date = new Date(props.selectedDate)
  const dayOfWeek = date.toLocaleDateString('ru-RU', { weekday: 'long' })
  const dayMonth = date.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long' })
  return `${dayMonth}, ${dayOfWeek}`
})

const isSelected = (slotId) => {
  return props.modelValue === slotId
}

const selectSlot = (slotId) => {
  emit('update:modelValue', slotId)
}

const formatPrice = (price, currency = props.currency) => {
  return formatCurrencyPrice(price, pickPreferredCurrency(currency, props.currency))
}
</script>

<style scoped lang="scss">
.time-slots {
  background: white;
  border-radius: 12px;
  margin-bottom: 16px;
}

.time-slots-title {
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 17px;
  font-weight: 700;
  line-height: 20px;
  color: #252525;
  margin: 0 0 8px 0;

  .trainer-name {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #757885;
  }
}

.selected-date {
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  color: #333333;
  text-transform: capitalize;
  margin-bottom: 16px;
}

.no-slots {
  padding: 32px;
  text-align: center;

  p {
    font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    font-size: 14px;
    color: #757885;
    margin: 0;
  }
}

.slots-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  gap: 8px;
}

.slot-button {
  width: 80px;
  height: 60px;
  background: #F3F5F8;
  border: none;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    background: darken(#F3F5F8, 5%);
  }

  &.active {
    background: var(--booking-widget-primary-color, #3C67D6);

    .slot-time,
    .slot-price {
      color: #FFFFFF;
    }
  }
}

.slot-time {
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  text-align: center;
  color: #333333;
}

.slot-price {
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  text-align: center;
  color: #757885;
}
</style>
